<template>
  <div class="view-bank-detail-container">
    <b-row>
      <b-col>
        <div>
          <bread-crumbs
            :page="$t('bank.list.page')"
            :section="getBankName()"
            :pageClick="openListOfBank"
          />
          <div class="spacing-32"></div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="9" v-if="bankLoading">
        <loader :height="400" />
      </b-col>
      <b-col lg="9" v-else>
        <!-- Bank view  -->
        <page-header title="Bank Account Details" />
        <div class="spacing-24"></div>
        <bank-information
          :bankDetails="bankDetails"
          :supporting_documents="supportingDocuments"
        />
        <div class="spacing-24"></div>
        <!-- bank view -->
      </b-col>
      <b-col lg="3">
        <!-- Widgets -->
      </b-col>
    </b-row>
  </div>
</template>
<script>
import BreadCrumbs from '@/components/common/BreadCrumbs'
import userService from '@/services/user'
import exportersService from '@/services/exporters'
import PageHeader from '@/components/common/PageHeader'
import Loader from '@/components/common/Loader'
import BankInformation from '@/components/bank-accounts/components/BankInformation'

export default {
  data() {
    return {
      bankDetails: {},
      supportingDocuments: [],
      bankLoading: false
    }
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    const bankId = this.$route.params.bid || this.$route.query.bid
    if (bankId) {
      this.fetchBank(bankId)
    } else {
      this.$router.push({ name: 'bankAccounts' })
    }
  },
  methods: {
    getBankName() {
      return (this.bankDetails && this.bankDetails.bank_name) || ''
    },
    openListOfBank() {
      this.$mpTrack(`Bank details - Navigate to bank list`)
      this.$router.push({ name: 'bankAccounts' })
    },
    fetchBank(bandId) {
      this.bankLoading = true
      userService.fetchAccessToken().then((res) => {
        exportersService
          .fetchBankDetailsData(res.data.token, bandId)
          .then((r) => {
            this.bankDetails = r.data
            this.supportingDocuments = r.data.supporting_documents
            this.bankLoading = false
          })
          .catch((e) => {
            this.bankLoading = false
            console.error(e)
          })
      })
    }
  },
  components: {
    BreadCrumbs,
    PageHeader,
    Loader,
    BankInformation
  }
}
</script>
<style lang="scss" scoped>
.view-bank-detail-container {
  padding: 40px 108px;
  @media screen and (max-width: 1025px) {
    padding: 40px 40px;
  }
  @media screen and (max-width: 576px) {
    padding: 40px 12px;
  }
}
</style>
